import { supplierDefs } from '@purchase/supplier';

/** 关联供应商卡片（DTO 仅 vendorId/vendorName，后端实际返回富字段，此处本地扩展） */
export interface RelatedVendorCard {
  vendorId?: string;
  vendorName?: string;
  desc?: string;
  tagId?: string | number;
  tagLevel?: string | number;
  tags?: { label?: string; tagLevel?: string | number }[];
}

/** 事故详情数据（DTO 缺 demandNames / relatedVendors 富字段 / responsibleServiceTypeName / remark，此处本地扩展） */
export type AccidentDetailData = supplierDefs.AccidentDetailDto & {
  demandNames?: string[];
  relatedVendors?: RelatedVendorCard[];
  responsibleServiceTypeName?: string;
  remark?: string;
};

/** tagLevel → 关联供应商卡片标签配色（1/2 红、3/4 橙，对齐 Figma 设计稿） */
export const VENDOR_TAG_COLOR: Record<string, { bg: string; color: string }> = {
  '1': { bg: '#ffebe6', color: '#e55140' },
  '2': { bg: '#ffebe6', color: '#e55140' },
  '3': { bg: '#fff6e5', color: '#e08216' },
  '4': { bg: '#fff6e5', color: '#e08216' },
};

/** 事故等级 → Tag 内联样式（精确 hex，对齐设计稿） */
export const LEVEL_TAG_STYLE: Record<string, React.CSSProperties> = {
  P0: { background: '#ffebe6', color: '#e55140' },
  P1: { background: '#FFF6E5', color: '#e08216' },
  P2: { background: '#E0F1FF', color: '#1e40af' },
  P3: { background: '#f5f5f5', color: '#666666' },
};
